const windowLogId = 'rendererLog';
const showWindowLogActionId = 'workbench.action.showWindowLog';
export { showWindowLogActionId, windowLogId };
